module.exports = {"id":"209331","name":"Mohamed Salah","rating":"86","photo":"./data/images/photos/0/209331.png","club":{"name":"Liverpool","logo":"./data/images/clubs/Liverpool.png"},"positions":["AD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MohamedSalah0.json
// module id = 3064
// module chunks = 0